module.exports = __webpack_public_path__ + "img/base_video.1ef26bca.svg";